export const CONFIG = {
  WHATSAPP_NUMBER: '50685316690', // Editable
  EXPRESS_FEE: 1500, // Editable, in colones
  CURRENCY_SYMBOL: '₡',
  LOGO_URL:
    'https://cdn.magicpatterns.com/uploads/qk6d1qkU1PDbDUUpyggcRc/Screenshot_2026-03-17_at_3.13.55_PM.png',
  APP_NAME: 'Emilius Pizza',
  APP_TAGLINE: 'Pizzería & Restaurante',
  // Operating hours (24h format, local time) — TESTING: disabled
  OPEN_HOUR: 0, // 0:00 AM (disabled for testing)
  CLOSE_HOUR: 24, // 12:00 AM (disabled for testing)
  // KDS Admin PIN (change this to your own PIN)
  ADMIN_PIN: '4321',
}
